var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.00833511L0 18.3992V20H20V18.3992L10 0.00833511ZM13.0842 9.17L12.4342 10.4092L10.8558 8.03084L8.71 11.4192L7.00167 9.0075L9.99833 3.49584L13.0825 9.16833L13.0842 9.17ZM1.93333 18.3333L6.11667 10.64L8.78917 14.4133L10.89 11.0958L12.6042 13.6783L14.0433 10.9333L18.0675 18.3342L1.93333 18.3333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/Mountain.5cd4208f651cdfeeb282fa78ca6e2ac1.svg";
export { ForwardRef as ReactComponent };